import React from 'react';
import { ClusterContactCreateDto, ClusterMemberCreateDto } from 'src/api/v2';

export interface CreateMemberContextProps {
  organizationNumber: string;
  submitting: boolean;

  member?: ClusterMemberCreateDto;
  contacts: ClusterContactCreateDto[];
}

const initialValue: CreateMemberContextProps = {
  organizationNumber: '',
  submitting: false,
  member: undefined,
  contacts: [],
};

export const CreateMemberContext = React.createContext<CreateMemberContextProps>(initialValue);
